import React, { useEffect, useState, memo } from "react";
import {
  Container,
  Grid,
  makeStyles,
  Typography,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  Chip,
  Box,
  IconButton,
} from "@material-ui/core";
import DashboardIcon from '@material-ui/icons/Dashboard';
import AssignmentIcon from "@material-ui/icons/Assignment";
import WorkIcon from "@material-ui/icons/Work";
import WarningIcon from "@material-ui/icons/Warning";
import EventNoteIcon from "@material-ui/icons/EventNote";
import DoneIcon from "@material-ui/icons/Done";
import { Header } from "components";
import Page from "components/Page";
import LogoDashAzul from "assets/logo dashboard azul.svg";
import LogoBlanco from "assets/logo dashboard blanco.svg";
import Icon1 from "assets/dashboard -02.png";
import Icon2 from "assets/dashboard -03.png";
import serviciosTablero from "utils/serviciosTablero";
import AvisoTareas from "./components/AvisoTareas";
import InfoCards from "./components/InfoCards";

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    backgroundColor: "#2d3239",
    minHeight: "65vh",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    borderRadius: "15px",
  },
  add: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    color: "white",
    backgroundColor: theme.palette.add.main,
    "&:hover": {
      backgroundColor: "#4D8487",
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },

    height: "50%",
  },
  refresh: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    color: "white",
    backgroundColor: "#3cd938b0",
    "&:hover": {
      backgroundColor: "#319E2E",
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },

    height: "50%",
  },
  contenedor: {
    backgroundColor: "#fff",
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    borderRadius: "15px",
  },
  tarjetas: {
    maxWidth: 400,
    borderRadius: 12,
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: "0 6px 25px rgba(0, 0, 0, 0.15)",
    },
  },
  avisoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    marginBottom: theme.spacing(3),
  },
  iconLeft: {
    fontSize: "3rem",
    marginRight: theme.spacing(2),
  },
  avisoContent: {
    flex: 1,
    textAlign: "left",
  },
  avisoTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: theme.palette.warning.dark,
  },
  avisoStat: {
    fontWeight: 500,
    color: theme.palette.warning.dark,
  },
  actionIcon: {
    color: theme.palette.warning.dark,
  },

  // Indicadores compactos
  indicatorContainer: {
    padding: theme.spacing(2),
    textAlign: "center",
    borderRadius: theme.shape.borderRadius,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  indicatorIcon: {
    fontSize: "3rem",
    color: theme.palette.secondary.main,
  },
  indicatorCount: {
    fontSize: "2rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
    margin: theme.spacing(1, 0),
  },
  indicatorLabel: {
    fontSize: "1rem",
    color: theme.palette.text.secondary,
  },

  // Tarjetas informativas estilo indicador
  cardContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    marginBottom: theme.spacing(2),
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    marginRight: theme.spacing(2),
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardContent: {
    flex: 1,
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: "1.2rem",
  },
  cardCount: {
    fontWeight: 500,
    fontSize: "1.5rem",
  },
}));

const Solicitud = ({ permisos, usuario }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [tableros, setTableros] = useState("");
  const [tarjetas, setTarjetas] = useState([]);
  const [mensaje, setMensaje] = useState({ open: false });
  const [catalogos, setCatalogos] = useState({ proyectos: [], areas: [] });
  const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: "" });

  const tareaColor = "#81c784 "; // Verde
  const proyectoColor = "#64b5f6   "; // Azul

  const gettableros = () => {
    serviciosTablero.getTableros(
      (status, mensaje, data) => {
        if (status === 1) {
          setTableros(data?.tableros);
        } else {
          console.error("Error al obtener las etiquetas:", mensaje);
        }
      },
      setCargando,
      { idusuario: usuario[0]?.idusuario }
    );
  };
  const getFechas = () => {
    serviciosTablero.getTarjetasFechas(
      (status, mensaje, data) => {
        if (status === 1) {
          setTarjetas(data);
        } else {
          console.error("Error al obtener las etiquetas:", mensaje);
        }
      },
      setCargando,
      { idusuario: usuario[0]?.idusuario }
    );
  };
  useEffect(() => {
    gettableros();
    getFechas();
  }, []);

  return (
    <Page className={classes.root} title="INICIO" cargando={cargando}>
      <Container maxWidth="lg" style={{ padding: "15px" }}>
        <Grid container spacing={2} alignItems="center">
          {/* Sección de bienvenida */}
          <Grid
            item
            xs={12}
            sm={8}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#2d3239", // Cambia al color deseado
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <Typography
              variant="h4"
              style={{ color: "white", flex: 1, marginRight: "20px" }}
            >
              ¡BIENVENIDO! 👋 <br />
              <span style={{ fontSize: "24px" }}>
                {`${usuario[0]?.nombre || ""} ${usuario[0]?.apaterno ||
                  ""} ${usuario[0]?.amaterno || ""}`}
              </span>
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            sm={3}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "5%",
              backgroundColor: "#2d3239",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <img
              src={LogoBlanco}
              style={{ height: "10vh", width: "40vh", marginTop: "20px" }}
            ></img>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          alignItems="center"
          style={{ marginTop: "45px" }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <InfoCards
              icon={<DashboardIcon />}
              title="Tableros asignados"
              count={tableros}
              color={tareaColor}
            />
            <InfoCards
              icon={<AssignmentIcon />}
              title="Tarjetas asignadas"
              count={tarjetas?.tarjetas}
              color={proyectoColor}
            />

            <AvisoTareas tarjetas={tarjetas} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default Solicitud;
